module.exports = __webpack_public_path__ + "static/media/engineering_ualberta.bd5f7709.jpg";